export default defineNuxtPlugin((nuxt) => {
  const nonce = generateRandomString(32);
  useHead({
    script: [
      {
        key: 'ad-blocker-stats',
        src: 'https://fundingchoicesmessages.google.com/i/pub-9930711021132174?ers=1',
        async: true,
        nonce
      },
      {
        key: 'googlefc-present',
        innerHTML: `(function() {
        function signalGooglefcPresent() {
          if (!window.frames['googlefcPresent']) {
            if (document.body) {
              const iframe = document.createElement('iframe');
              iframe.style = 'width: 0; height: 0; border: none; z-index: -1000; left: -1000px; top: -1000px;';
              iframe.style.display = 'none';
              iframe.name = 'googlefcPresent';
              document.body.appendChild(iframe);
            } else {
              setTimeout(signalGooglefcPresent, 0);
            }
          }
        }
        signalGooglefcPresent();
      })();`,
        type: 'text/javascript',
        nonce
      }
    ]
  });
});
